import { ExternalLink } from "lucide-react";

export const SOCIAL_KEYS = ["instagram", "facebook", "linkedin", "youtube", "twitter", "website"];
const label = (k) => k.charAt(0).toUpperCase() + k.slice(1);

export const SocialLinksEditor = ({ value = {}, onChange, testid = "social" }) => (
  <div className="grid sm:grid-cols-2 gap-2">
    {SOCIAL_KEYS.map((k) => (
      <input key={k} data-testid={`${testid}-${k}`} value={value[k] || ""} placeholder={`${label(k)} profile URL`}
        onChange={(e) => onChange({ ...value, [k]: e.target.value })} className="nb-input" />
    ))}
  </div>
);

export const SocialLinksList = ({ links = {}, testid = "social-link" }) => {
  const rows = Object.entries(links).filter(([, v]) => v);
  if (!rows.length) return null;
  return (
    <div className="flex flex-wrap gap-2" data-testid={`${testid}s`}>
      {rows.map(([k, v]) => (
        <a key={k} href={v.startsWith("http") ? v : `https://${v}`} target="_blank" rel="noreferrer" data-testid={`${testid}-${k}`}
          className="nb-badge bg-white hover:bg-lime-100 transition-colors duration-150"><ExternalLink className="w-3 h-3" /> {label(k)}</a>
      ))}
    </div>
  );
};
